import React from 'react';
import ListViewRefreshMenu from '../ListViewRefreshMenu';
import ListViewRefreshStatus from '../ListViewRefreshStatus';
import type { RefreshControl, TimeFormatSetting } from '../../types';

/* How fresh the shown bookings are, and what can be done about it: when they
 * were last refreshed, and the refresh button with the menu holding the
 * auto-refresh interval. They sit at the right edge of the toolbar's display
 * band — the end the actions live at. */

interface ListViewRefreshProps {
  refreshControl: RefreshControl;
  timeFormatSetting: TimeFormatSetting;
}

const ListViewRefresh = ({
  refreshControl,
  timeFormatSetting
}: ListViewRefreshProps) => {
  const {
    intervalMinutes,
    isRefreshing,
    lastRefreshedAt,
    failed,
    onIntervalChange,
    onRefreshNow
  } = refreshControl;
  return (
    <div tw="flex items-center space-x-4" data-test-list-view-refresh>
      <ListViewRefreshStatus
        isRefreshing={isRefreshing}
        failed={failed}
        lastRefreshedAt={lastRefreshedAt}
        timeFormatSetting={timeFormatSetting}
      />
      <ListViewRefreshMenu
        intervalMinutes={intervalMinutes}
        isRefreshing={isRefreshing}
        onIntervalChange={onIntervalChange}
        onRefreshNow={onRefreshNow}
      />
    </div>
  );
};

export default ListViewRefresh;
